import type { Partner } from "@expert/shared-types";

import type { Subscription } from "../graphql";
import type { Subscriptions } from "./types";

import { useExpertAssistStore } from "./store";

export const setSessionDetails = (sessionId: string, callSid?: string, partner?: Partner) => {
    useExpertAssistStore.getState().setSessionDetails({ sessionId, callSid: callSid ?? undefined, partner });
};

export const setSubscription = (id: keyof Subscriptions, subscription?: Subscription) => {
    useExpertAssistStore.getState().setSubscription(id, subscription);
};
